(function () {
  if (window.__customVariantFieldsInit) return;
  window.__customVariantFieldsInit = true;

  function normalize(value) {
    return (value || '').trim().toLowerCase();
  }

  function getSelectedValues(variantSelects) {
    if (!variantSelects) return [];
    var values = [];
    variantSelects
      .querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked')
      .forEach(function (input) {
        values.push(input.value);
      });
    variantSelects.querySelectorAll('select').forEach(function (select) {
      if (select.value) values.push(select.value);
    });
    return values.map(normalize);
  }

  function evaluateContainer(container) {
    var vsId = container.getAttribute('data-variant-selects');
    var variantSelects =
      (vsId && document.getElementById(vsId)) ||
      (container.closest('product-info') && container.closest('product-info').querySelector('variant-selects'));
    var selected = getSelectedValues(variantSelects);

    container.querySelectorAll('template[data-custom-field-template]').forEach(function (template) {
      var trigger = normalize(template.getAttribute('data-custom-field-trigger'));
      var show = selected.indexOf(trigger) !== -1;
      var existing = container.querySelector(
        '[data-custom-field][data-custom-field-trigger="' + trigger + '"]'
      );

      if (show && !existing) {
        var clone = template.content.cloneNode(true);
        template.parentNode.insertBefore(clone, template.nextSibling);
      } else if (!show && existing) {
        existing.remove();
      }
    });
  }

  function evaluateAll() {
    document.querySelectorAll('[data-custom-variant-fields]').forEach(evaluateContainer);
  }

  function init() {
    evaluateAll();

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, evaluateAll);
    }

    // Fallbacks: covers variant re-renders and non-pubsub interactions.
    document.addEventListener('variant:changed', evaluateAll);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-selects')) {
        evaluateAll();
      }
    });
    document.addEventListener('shopify:section:load', evaluateAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
